import i18n from '@/plugins/i18n'

export const getEvaluationUnits = () => [
    {
        // header: i18n.t('common.distance'),
        name: i18n.t('units.meters'),
        value: 'meters'
    },
    {
        // header: i18n.t('common.distance'),
        name: i18n.t('units.yards'),
        value: 'yards'
    },
    {
        // header: i18n.t('common.time'),
        name: i18n.t('units.seconds'),
        value: 'seconds',
    },
    // {
    //     // header: i18n.t('common.time'),
    //     name: i18n.t('units.minutes_seconds'),
    //     value: 'minutes_seconds'
    // },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.newton'),
        value: 'newton'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.watts'),
        value: 'watts'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.weight_kg'),
        value: 'weight_kg'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.weight_lb'),
        value: 'weight_lb'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.angles'),
        value: 'angles'
    },
    {
        // header: i18n.t('common.others'),
        name: i18n.t('units.none'),
        value: 'none'
    },
    {
        name: i18n.t('units.speed_ms'),
        value: 'speed_ms'
    },
    {
        name: i18n.t('units.speed_kmh'),
        value: 'speed_kmh'
    },
    {
        name: i18n.t('units.ml_kg_min'),
        value: 'ml_kg_min'
    },
    {
        name: i18n.t('units.repetitions'),
        value: 'repetitions'
    },
    {
        name: i18n.t('units.centimeters'),
        value: 'centimeters'
    },
    {
        name: i18n.t('units.newton_kg'),
        value: 'newton_kg'
    },
    {
        name: i18n.t('units.tdf'),
        value: 'tdf'
    },
]

export const getQuestions = () => [
    {
        id: 1,
        title: i18n.t('questions.sleep_night'),
        value: 'sleep_night',
        type: 'scale',
        icon: '$sleep',
        force: true,
        comment: true,
        reference: i18n.t('questions.sleep_night_ref'),
        options: [
            { value: 5, text: i18n.t('questions.sleepNightOptions.5') },
            { value: 4, text: i18n.t('questions.sleepNightOptions.4') },
            { value: 3, text: i18n.t('questions.sleepNightOptions.3') },
            { value: 2, text: i18n.t('questions.sleepNightOptions.2') },
            { value: 1, text: i18n.t('questions.sleepNightOptions.1') },
        ]
    },
    {
        id: 2,
        title: i18n.t('questions.muscles_hurt'),
        value: 'muscles_hurt',
        type: 'scale',
        icon: '$bad_face',
        reference: i18n.t('questions.muscles_hurt_ref'),
        force: true,
        comment: true,
        options: [
            { value: 5, text: i18n.t('questions.musclesHurtOptions.5') },
            { value: 4, text: i18n.t('questions.musclesHurtOptions.4') },
            { value: 3, text: i18n.t('questions.musclesHurtOptions.3') },
            { value: 2, text: i18n.t('questions.musclesHurtOptions.2') },
            { value: 1, text: i18n.t('questions.musclesHurtOptions.1') },
        ]
    },
    {
        id: 3,
        title: i18n.t('questions.tired'),
        value: 'tired',
        type: 'scale',
        icon: '$reload_energy',
        reference: i18n.t('questions.tired_ref'),
        force: true,
        comment: true,
        options: [
            { value: 5, text: i18n.t('questions.tiredOptions.5') },
            { value: 4, text: i18n.t('questions.tiredOptions.4') },
            { value: 3, text: i18n.t('questions.tiredOptions.3') },
            { value: 2, text: i18n.t('questions.tiredOptions.2') },
            { value: 1, text: i18n.t('questions.tiredOptions.1') },
        ]
    },
    {
        id: 4,
        title: i18n.t('questions.stressed'),
        value: 'stressed',
        type: 'scale',
        force: true,
        icon: '$mental_energy',
        reference: i18n.t('questions.stressed_ref'),
        comment: true,
        options: [
            { value: 5, text: i18n.t('questions.stressedOptions.5') },
            { value: 4, text: i18n.t('questions.stressedOptions.4') },
            { value: 3, text: i18n.t('questions.stressedOptions.3') },
            { value: 2, text: i18n.t('questions.stressedOptions.2') },
            { value: 1, text: i18n.t('questions.stressedOptions.1') },
        ]
    },
    {
        id: 5,
        title: i18n.t('questions.energy'),
        value: 'energy',
        type: 'scale',
        force: true,
        icon: '$battery',
        reference: i18n.t('questions.energy_ref'),
        comment: true,
        options: [
            { value: 5, text: i18n.t('questions.energyOptions.5') },
            { value: 4, text: i18n.t('questions.energyOptions.4') },
            { value: 3, text: i18n.t('questions.energyOptions.3') },
            { value: 2, text: i18n.t('questions.energyOptions.2') },
            { value: 1, text: i18n.t('questions.energyOptions.1') },
        ]
    },
    {
        id: 6,
        title: i18n.t('questions.sleep_hours'),
        value: 'sleep_hours',
        type: 'slider',
        unit: 'questions.units.hours',
        reference: i18n.t('questions.sleep_hours_ref'),
        min: 1,
        max: 15,
        comment: true,
    },
    {
        id: 7,
        title: i18n.t('questions.weighing'),
        value: 'weighing',
        type: 'slider',
        unit: 'questions.units.kg',
        reference: i18n.t('questions.weighing_ref'),
        min: 1,
        max: 150
    },
    {
        id: 8,
        title: i18n.t('questions.body_hurts'),
        value: 'body_hurts',
        type: 'body',
        reference: i18n.t('questions.body_hurts_ref'),
        comment: true,
        options: [
            {
                title: i18n.t('questions.bodyHurtsOptions.lower_limb.title'),
                zones: [
                    { value: "hip", text: i18n.t('questions.bodyHurtsOptions.lower_limb.hip') },
                    { value: "glute", text: i18n.t('questions.bodyHurtsOptions.lower_limb.glute') },
                    { value: "pubis", text: i18n.t('questions.bodyHurtsOptions.lower_limb.pubis') },
                    { value: "adductor", text: i18n.t('questions.bodyHurtsOptions.lower_limb.adductor') },
                    { value: "quadriceps", text: i18n.t('questions.bodyHurtsOptions.lower_limb.quadriceps') },
                    { value: "hamstring", text: i18n.t('questions.bodyHurtsOptions.lower_limb.hamstring') },
                    { value: "knee", text: i18n.t('questions.bodyHurtsOptions.lower_limb.knee') },
                    { value: "calf", text: i18n.t('questions.bodyHurtsOptions.lower_limb.calf') },
                    { value: "soleus", text: i18n.t('questions.bodyHurtsOptions.lower_limb.soleus') },
                    { value: "ankle", text: i18n.t('questions.bodyHurtsOptions.lower_limb.ankle') },
                    { value: "foot", text: i18n.t('questions.bodyHurtsOptions.lower_limb.foot') }
                ]
            },
            {
                title: i18n.t('questions.bodyHurtsOptions.torax.title'),
                zones: [
                    { value: "lumbar", text: i18n.t('questions.bodyHurtsOptions.torax.lumbar') },
                    { value: "dorsal", text: i18n.t('questions.bodyHurtsOptions.torax.dorsal') },
                    { value: "cervical", text: i18n.t('questions.bodyHurtsOptions.torax.cervical') },
                    { value: "abdomen_mid", text: i18n.t('questions.bodyHurtsOptions.torax.abdomen_mid') },
                    { value: "abdomen_side", text: i18n.t('questions.bodyHurtsOptions.torax.abdomen_side') }
                ]
            },
            {
                title: i18n.t('questions.bodyHurtsOptions.upper_limb.title'),
                zones: [
                    { value: "head", text: i18n.t('questions.bodyHurtsOptions.upper_limb.head') },
                    { value: "neck", text: i18n.t('questions.bodyHurtsOptions.upper_limb.neck') },
                    { value: "trapezius", text: i18n.t('questions.bodyHurtsOptions.upper_limb.trapezius') },
                    { value: "pectoral", text: i18n.t('questions.bodyHurtsOptions.upper_limb.pectoral') },
                    { value: "deltoid", text: i18n.t('questions.bodyHurtsOptions.upper_limb.deltoid') },
                    { value: "clavicle", text: i18n.t('questions.bodyHurtsOptions.upper_limb.clavicle') },
                    { value: "shoulder", text: i18n.t('questions.bodyHurtsOptions.upper_limb.shoulder') },
                    { value: "triceps", text: i18n.t('questions.bodyHurtsOptions.upper_limb.triceps') },
                    { value: "biceps", text: i18n.t('questions.bodyHurtsOptions.upper_limb.biceps') },
                    { value: "elbow", text: i18n.t('questions.bodyHurtsOptions.upper_limb.elbow') },
                    { value: "forearm", text: i18n.t('questions.bodyHurtsOptions.upper_limb.forearm') },
                    { value: "hand", text: i18n.t('questions.bodyHurtsOptions.upper_limb.hand') },
                    { value: "wrist", text: i18n.t('questions.bodyHurtsOptions.upper_limb.wrist') },
                    { value: "finger", text: i18n.t('questions.bodyHurtsOptions.upper_limb.finger') }
                ]
            }
        ]
    },
    {
        id: 9,
        title: i18n.t('questions.hurt'),
        value: 'hurt',
        type: 'slider_vertical',
        reference: i18n.t('questions.hurt_ref'),
        min: 0,
        max: 10,
        comment: true,
    },
    {
        id: 10,
        title: i18n.t('questions.available'),
        value: 'available',
        type: 'scale',
        reference: i18n.t('questions.available_ref'),
        comment: true,
        options: [
            { value: 4, text: i18n.t('questions.availableOptions.4') },
            { value: 3, text: i18n.t('questions.availableOptions.3') },
            { value: 2, text: i18n.t('questions.availableOptions.2') },
            { value: 1, text: i18n.t('questions.availableOptions.1') },
        ]
    },
    {
        id: 11,
        title: i18n.t('questions.test'),
        value: 'test',
        type: 'statistic',
        reference: i18n.t('questions.test_ref'),
    },
]